// @ts-nocheck
import type { CompiledRuntimeNode } from '../compiler';
import type { PressHandlerInput } from '../../types/eventHandler';
import { normalizeEventHandler } from '../../types/eventHandler';

function handlerKey(handler: PressHandlerInput): string | null {
  const normalized = normalizeEventHandler(handler);
  if (normalized === null) return null;
  if (normalized.kind === 'script') return `script:${normalized.scriptId}`;
  if (normalized.kind === 'animation') return `animation:${normalized.animationId}`;
  return `action:${normalized.actionId}`;
}

/** Deduplicated handler list preserving first-seen order. */
export function dedupePressHandlers(
  handlers: readonly (PressHandlerInput | null | undefined)[],
): PressHandlerInput[] {
  const seen = new Set<string>();
  const out: PressHandlerInput[] = [];
  for (const handler of handlers) {
    if (handler == null) continue;
    const key = handlerKey(handler);
    if (key === null || seen.has(key)) continue;
    seen.add(key);
    out.push(handler);
  }
  return out;
}

/** All press handlers for a compiled node (button/icon.action + interactions.onPress*). */
export function collectPressHandlers(node: CompiledRuntimeNode): PressHandlerInput[] {
  const props = node.props as {
    button?: { action?: PressHandlerInput };
    icon?: { action?: PressHandlerInput };
  };
  const kindAction = props.button?.action ?? props.icon?.action;
  return dedupePressHandlers([
    kindAction,
    node.interactions?.onPress,
    ...(node.interactions?.onPressHandlers ?? []),
  ]);
}

/** All change handlers for a compiled node (interactions.onChange*). */
export function collectChangeHandlers(node: CompiledRuntimeNode): PressHandlerInput[] {
  return dedupePressHandlers([
    node.interactions?.onChange,
    ...(node.interactions?.onChangeHandlers ?? []),
  ]);
}
